// Version : 1.0.0
// Author : AGALYA
import { takeLatest, put, all, call } from 'redux-saga/effects';
import BankDetailsActionType from './bank-details.types';
import {
	bankCreateSuccess,
	bankCreateFailure,
	bankResponseChanged,
	bankIFSCcodeSuccess,
	bankIFSCcodeFailure,
	bankIFSCcodeChanged,
} from './bank-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { basnkMemberDetailsAdd, BankIFSCCreate } from './bank-details.service';

/** ***************** BANK DETAILS CREATE START *********************** */
export function* AddBankDetails({ payload }: any) {
	try {
		const key = 'AddMemberBankDetails';
		const {
			companyID,
			databaseName,
			memberID,
			accountNumber,
			reEnterAccountNumber,
			accountHolderName,
			ifscCode,
			bankName,
			bankBranchName,
			rbiStatus,
			accountType,
			isBankTransaction,
			userID,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			AccountNumber: accountNumber,
			ReEnterAccountNumber: reEnterAccountNumber,
			AccountHolderName: accountHolderName,
			IFSCCode: ifscCode,
			BankName: bankName,
			BankBranchName: bankBranchName,
			RbiStatus: rbiStatus,
			AccountType: accountType,
			IsBankTransaction: isBankTransaction,
			OfficerID: userID,
			Secratekey: key,
		};
		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(basnkMemberDetailsAdd, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(bankCreateFailure(responseData.data));
		} else {
			yield put(bankCreateSuccess(responseData.data));
		}
	} catch (error) {
		yield put(bankCreateFailure(error));
	}
}

export function* AddBankDetailsResponseClear() {
	yield put(bankResponseChanged());
}

export function* onBankDetailsAddStart() {
	yield takeLatest(BankDetailsActionType.BANK_DETAILS_CREATE_START, AddBankDetails);
}

export function* onBankDetailsAddResponseRest() {
	yield takeLatest(
		BankDetailsActionType.BANK_DETAILS_CREATE_RESPONSE_REST_START,
		AddBankDetailsResponseClear,
	);
}
/** ***************** BANK DETAILS CREATE END *********************** */

/** ***************** BANK IFSC CODE RESPONSE START *********************** */
export function* bankIFSCcode({ payload: { ifscCode } }: any) {
	try {
		// @ts-ignore
		const responseData = yield call(BankIFSCCreate, ifscCode);
		if (responseData.status === 200) {
			yield put(bankIFSCcodeSuccess(responseData.data));
		} else {
			yield put(bankIFSCcodeFailure(responseData.data));
		}
	} catch (error) {
		yield put(bankIFSCcodeFailure(error));
	}
}

export function* bankIFSCcodeChange() {
	yield put(bankIFSCcodeChanged());
}

export function* onBankIFSCcodeStart() {
	yield takeLatest(BankDetailsActionType.BANK_IFSC_CODE_RESPONSE_START, bankIFSCcode);
}

export function* onBankIFSCcodeChange() {
	yield takeLatest(BankDetailsActionType.BANK_IFSC_CODE_RESPONSE_RESET, bankIFSCcodeChange);
}
/** ***************** BANK IFSC CODE RESPONSE END *********************** */

export function* memberBankDetailsSaga() {
	yield all([
		call(onBankDetailsAddStart),
		call(onBankDetailsAddResponseRest),
		call(onBankIFSCcodeStart),
		call(onBankIFSCcodeChange),
	]);
}
